import styled from '@emotion/styled';

export const NaturalPersonViewSpouseSectionContainer = styled.div`
  margin-bottom: 50px;
`;
